import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl21 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_21",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Arrow",
				className: "black",
				d: "M19.11,21.26c.1-.24.1-.52,0-.76-.05-.12-.12-.23-.22-.33l-5-5c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l3.29,3.29H6.19c-.55,0-1,.45-1,1s.45,1,1,1h9.59l-3.29,3.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l5-5c.09-.09.17-.2.22-.33Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Station",
				className: "black",
				d: "M38,24c0-2.76-2.24-5-5-5s-5,2.24-5,5,2.24,5,5,5,5-2.24,5-5ZM33,27c-1.66,0-3-1.34-3-3s1.34-3,3-3,3,1.34,3,3-1.34,3-3,3ZM54.22,33.01h-.22s-9,0-9,0v-15c0-2.68-2.11-4.88-4.78-4.99h-.22s-14,0-14,0c-2.68,0-4.88,2.11-4.99,4.78v.22s0,11,0,11c0,.55.45,1,1,1,.51,0,.93-.38.99-.88v-.12s0-11,0-11c0-1.59,1.24-2.9,2.82-2.99h.18s14,0,14,0c1.59,0,2.9,1.24,2.99,2.82v.18s0,33,0,33h-4v-11c0-1.59-1.24-2.9-2.82-2.99h-.18s-1,0-1,0c-.55,0-1,.45-1,1,0,.51.38.93.88.99h.12s1,0,1,0c.51,0,.93.38.99.88v.12s0,12,0,12c0,.51.38.93.88.99h.12s5,0,5,0h15c.51,0,.93-.38.99-.88v-.12s0-14,0-14c0-2.68-2.11-4.88-4.78-4.99ZM53,51h-4v-10.97c0-.46.32-.87.77-.97l.11-.02h.12s2,0,2,0c.51,0,.93.38.99.88v.12s0,10.97,0,10.97ZM55,51v-10.97c0-1.59-1.24-2.9-2.82-3h-.18s-2,0-2,0c-1.59,0-2.9,1.24-2.99,2.82v.18s0,10.97,0,10.97h-2v-16h9c1.59,0,2.9,1.24,2.99,2.82v.18s0,13,0,13h-2Z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "ICE_Sideview",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "red",
						d: "M34,49H9c-.55,0-1-.45-1-1s.45-1,1-1h25c.55,0,1,.45,1,1s-.45,1-1,1Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M25,53H9c-.55,0-1-.45-1-1s.45-1,1-1h16c9,0,9-2.52,9-4.03,0-2.39-2.66-5.91-6.62-8.76-4.56-3.41-9.63-5.21-14.69-5.21h-3.69c-.55,0-1-.45-1-1s.45-1,1-1h3.69c5.49,0,10.98,1.93,15.88,5.59,4.58,3.3,7.44,7.28,7.44,10.38,0,4.23-3.29,6.03-11,6.03Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "black",
						d: "M21.76,42.78s-.1,0-.15-.01l-.5-.07c-3.2-.47-6.48-.7-10.02-.7h-2.09c-.55,0-1-.45-1-1s.45-1,1-1h2.09c3.64,0,7.01.24,10.31.72l.94-.94c-3.08-1.82-6.66-2.78-10.34-2.78h-3c-.55,0-1-.45-1-1s.45-1,1-1h3c4.04,0,7.97,1.06,11.36,3.06l1.11.66c.27.16.45.43.48.74s-.07.61-.29.83l-2.21,2.21c-.19.19-.44.29-.71.29Z"
					})
				]
			})
		]
	})]
});
export default SvgAppIcBefehl21;
